var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeleteWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.0499 6.0001L11.4999 1.5501C11.7999 1.2501 11.7999 0.800098 11.4999 0.500098C11.1999 0.200098 10.7499 0.200098 10.4499 0.500098L5.9999 4.9501L1.5499 0.450098C1.2499 0.150098 0.799902 0.150098 0.499902 0.450098C0.199902 0.750098 0.199902 1.2001 0.499902 1.5001L4.9499 5.9501L0.499902 10.4001C0.199902 10.7001 0.199902 11.1501 0.499902 11.4501C0.649902 11.6001 0.849902 11.6501 1.0499 11.6501C1.2499 11.6501 1.4499 11.6001 1.5999 11.4501L6.0499 7.0001L10.4999 11.4501C10.6499 11.6001 10.8499 11.6501 11.0499 11.6501C11.2499 11.6501 11.4499 11.6001 11.5999 11.4501C11.8999 11.1501 11.8999 10.7001 11.5999 10.4001L7.0499 6.0001Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteWhite);
export default __webpack_public_path__ + "static/media/delete_white.e2957721141ea6dfc85f37cfa8b327b0.svg";
export { ForwardRef as ReactComponent };